<template>
  <b-container>
    <b-row>
      <b-col>
        <span class="cs-footer-info-title">{{ content.title }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pt-3">
        <div class="cs-footer-info-description" v-html="descriptionFmt"></div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { replaceContentPlaceholder } from '@/utils/content';

export default {
  name: 'Info',
  props: {
    content: Object,
  },
  data() {
    return {};
  },
  computed: {
    descriptionFmt() {
      return this.content.description
        ? replaceContentPlaceholder(this.content.description,
          `<span class="cs-footer-info-link">${this.content.contact}</span>`)
        : '';
    },
  },
};
</script>

<style scoped lang="scss">
.cs-footer-info-title {
  color: $brandPrimaryColor;
  font-size: $footerItemsTitle;
  font-weight: bold;
}

.cs-footer-info-description {
  color: $footerPrimaryColor;
  font-size: $footerItemsText;
  text-align: justify;
  text-justify: inter-word;
}

/deep/ .cs-footer-info-link {
  color: $brandPrimaryColor;
}

</style>
